module.exports = __webpack_public_path__ + "static/img/llzfq3.7352b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/llzfq3.png
// module id = DDpx
// module chunks = 0